var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChefHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 11.0503 3.2341 12.8124 5 13.584V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V13.584C20.7659 12.8124 22 11.0503 22 9C22 6.23858 19.7614 4 17 4C16.6803 4 16.3676 4.03001 16.0645 4.08737C15.1571 2.82336 13.6747 2 12 2C10.3253 2 8.84287 2.82336 7.93548 4.08736C7.63244 4.03001 7.31972 4 7 4C4.23858 4 2 6.23858 2 9ZM9 17.25H15C15.4142 17.25 15.75 17.5858 15.75 18C15.75 18.4142 15.4142 18.75 15 18.75H9C8.58579 18.75 8.25 18.4142 8.25 18C8.25 17.5858 8.58579 17.25 9 17.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHat);
export default __webpack_public_path__ + "static/media/chef-hat.675be32cc885633550a2a0c9e18f608f.svg";
export { ForwardRef as ReactComponent };